module.exports = __webpack_public_path__ + "static/img/img_empty_page_def.77730310.svg";